import type { StripeCreateInvoiceResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

type mutationInputType = {
  invoiceIds: string[];
};

export function useSyncToStripe(
  options?: UseMutationOptions<StripeCreateInvoiceResponse, unknown, mutationInputType>,
) {
  const queryClient = useQueryClient();

  const mutationFn = (variables: mutationInputType) => {
    const api = getPrivateApi();

    return api.stripeCreateInvoice({
      stripeCreateInvoiceRequest: {
        invoicesIds: variables.invoiceIds,
      },
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.invoicesOverviewsNew());
    },
    ...options,
  });
}
